
import { Profile } from "@/hooks/profile/types";

export const validateProfileUpdate = (updates: Partial<Profile>) => {
  // Función para verificar si un campo está vacío
  const isFieldEmpty = (field: string | null | undefined): boolean => {
    if (field === null || field === undefined) return true;
    if (typeof field !== 'string') return true;
    return field.trim() === "";
  };

  // Validación exhaustiva antes de proceder
  const requiredFields = ['first_name', 'last_name', 'birthdate'];
  const missingFields = requiredFields.filter(field => 
    isFieldEmpty(updates[field as keyof Profile] as string)
  );

  if (missingFields.length > 0) {
    console.error("Attempt to save profile with missing fields:", missingFields, updates);
    throw new Error(`Los siguientes campos son obligatorios: ${missingFields.join(', ')}`);
  }

  // Validación adicional de longitud mínima
  if (updates.first_name && updates.first_name.trim().length < 2) {
    throw new Error("El nombre debe tener al menos 2 caracteres");
  }
  
  if (updates.last_name && updates.last_name.trim().length < 2) {
    throw new Error("El apellido debe tener al menos 2 caracteres");
  }

  // Validación de fecha de nacimiento (sin restricción de edad mínima)
  if (updates.birthdate) {
    const birthDate = new Date(updates.birthdate);
    const today = new Date();
    const minAge = new Date(today.getFullYear() - 100, today.getMonth(), today.getDate());

    if (birthDate > today) {
      throw new Error("La fecha de nacimiento no puede ser futura");
    }

    if (birthDate < minAge) {
      throw new Error("Por favor, ingresa una fecha de nacimiento válida");
    }
  }
};
